export default __webpack_public_path__ + "img/bnaiAmAg.179931d5.svg";